import { Injectable } from "@angular/core";
import { WebsocketService } from "./websocket.service";
import { RealTimeService } from "./realtime.service";
import Swal from 'sweetalert2';
import { Utils } from "src/app/common/utils";
import { VproService } from '../vpro/vpro.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SocketsConnectionService {

    constructor(private wsService: WebsocketService,
        private realTimeService: RealTimeService,
        private vs: VproService,
        private spinner: NgxSpinnerService) {

    }

    subscribeToSockets() {
        if (localStorage.getItem('uid')) {
            // establish the web sockets connection
            this.realTimeService.connect();
            // messages subscribed from backend
            this.realTimeService.messages.subscribe((msg: any) => {
                console.log(
                    "Received message:---> " + JSON.stringify(msg)
                );
                if (localStorage.getItem('uid')) {
                    let { type, data } = msg;
                    switch (type) {
                        case Utils.NOTIFICATION_TYPES.PHYSICIAN_AVAILABILITY_UPDATED:
                            this.hanldleNotificationsCount();
                            break;
                        case Utils.NOTIFICATION_TYPES.CONSULT_NOW:
                            this.handleConsultNow(msg);
                            break;
                        case Utils.NOTIFICATION_TYPES.APPOINTMENT_ADDED:
                            this.hanldleNotificationsCount();
                            break;
                        case Utils.NOTIFICATION_TYPES.APPOINTMENT_UPDATED:
                            this.hanldleNotificationsCount();
                            break;
                        case Utils.NOTIFICATION_TYPES.APPOINTMENT_DELETED:
                            this.hanldleNotificationsCount();
                            break;
                        case Utils.NOTIFICATION_TYPES.APPOINTMENT_REMINDER:
                            this.hanldleNotificationsCount();
                            this.handleToast(data, type);
                            break;
                        case Utils.NOTIFICATION_TYPES.CONSULT_NOW_ONE_HOUR:
                            this.handleConsultNow(msg, true);
                            break;
                        case Utils.CHAT_ACTION.NEW_MESSAGE:
                            this.handleChatMessage(msg);
                            break;
                        case Utils.NOTIFICATION_TYPES.ENABLE_ONLINE_CALL:
                            this.handleChatMessage(msg);
                            break;
                        case Utils.NOTIFICATION_TYPES.SEND_ATTACHMENT:
                            this.handleChatMessage(msg);
                            break;
                        case Utils.NOTIFICATION_TYPES.JOIN_CHAT:
                            this.handleChatMessage(msg);
                            break;
                        case Utils.NOTIFICATION_TYPES.PREVIOUS_CHAT:
                            this.handleChatMessage(msg)
                            break;
                        case Utils.NOTIFICATION_TYPES.TYPING_STATUS:
                            this.handleChatMessage(msg);
                        case Utils.messageAction.GETMESSAGES:
                            this.handleChatMessage(msg);
                    }
                }
            })
        }
    }

    disconnect() {
        this.realTimeService.disconnect();
    }

    handleConsultNow(msg, showCancel = false) {
        let { data, type, consult_now } = msg;
        this.vs.consultNowUpdate.next({
            consultNow: consult_now
        })
        this.handleToast(data, type, showCancel);
    }

    handleToast(data, type, showCancel = false) {
        let params = {
            toast: true,
            showConfirmButton: true,
            confirmButtonText: 'OK'
        };
        if (showCancel) {
            params['cancelButtonText'] = 'No';
            params['showCancelButton'] = true;
        }

        const Toast = Swal.mixin(params);
        Toast.fire({
            type: 'success',
            title: data,
        }).then((result) => {
            if (result.value) {
                console.log('alert ok');
                switch (type) {
                    case Utils.NOTIFICATION_TYPES.CONSULT_NOW_ONE_HOUR:
                        this.setConsultNow();
                        break;
                }
            }
        });
    }

    setConsultNow() {
        this.spinner.show();
        this.vs.setConsultNow(JSON.parse(localStorage.getItem("uid")), { consult_now: true }).subscribe(
            res => {
                this.spinner.hide();
                this.vs.consultNowUpdate.next({
                    consultNow: true
                })
            },
            err => {
                this.spinner.hide();
                console.log(err);
            });
    }

    hanldleNotificationsCount() {
        this.vs.notificationUpdate.next({
            type: 'count'
        });
    }

    handleChatMessage(msg) {
        console.log("inside chat message handeler",msg)
        let { id, type, u_id, room_id, message, data, contentType=null,name=null } = msg;
        this.vs.chatMessageSubject.next({
            id: id,
            u_id: u_id,
            room_id: room_id,
            message: message,
            type: type,
            name,
            contentType,
            data
        })
    }
}